export class PostMessageAPI {
    constructor(targetOrigin = '*') {
        this.targetOrigin = targetOrigin;
    }
    // Send events to parent window
    send(type, payload) {
        if (typeof window !== 'undefined' && window.parent) {
            window.parent.postMessage({
                type,
                payload,
                source: 'virtual-banker-widget',
            }, this.targetOrigin);
        }
    }
    // Listen for messages from parent window
    on(type, callback) {
        const handler = (event) => {
            if (event.data && event.data.type === type && event.data.source === 'virtual-banker-host') {
                callback(event.data.payload);
            }
        };
        window.addEventListener('message', handler);
        // Return unsubscribe function
        return () => {
            window.removeEventListener('message', handler);
        };
    }
    // Widget events
    ready() {
        this.send('ready');
    }
    sessionStarted(sessionId) {
        this.send('session_started', { sessionId });
    }
    actionRequested(action, params) {
        this.send('action_requested', { action, params });
    }
    actionCompleted(action, result) {
        this.send('action_completed', { action, result });
    }
    handoffToHuman(reason) {
        this.send('handoff_to_human', { reason });
    }
}
